<template>
  <vb-uploader
    :show-icon="false"
    :enabled="enabled"
    @upload-done="onUploadDone($event)"
  >
    <div v-if="showBox" class="dropzone">
      <div class="box">
        <i class="ion ion-upload" />
        <br />{{ title }}
      </div>
    </div>
    <a v-else href @click.prevent>{{ title }}</a>
  </vb-uploader>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Drop files here' },
    enabled: { type: Boolean, default: true },
    plainTitle: { type: Boolean, default: false },
  },
  computed: {
    showBox() {
      return !this.plainTitle
    },
  },
  methods: {
    onUploadDone(event) {
      this.$emit('upload-done', event)
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.vb-uploader.is-dragging > .dropzone {
  border-color: transparent;
  color: $yellow;
}

.dropzone {
  margin: 0px 0;
  padding: 10px 0;
  border: 2px dashed $grey150;
  border-radius: 4px;
  //background-color: lighten($yellow, 39%);
  color: $grey150;
  display: flex; /* establish flex container */
  flex-direction: column; /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center; /* center items horizontally, in this case */
  min-height: 100px;

  .box {
    width: 300px;
    margin: 5px;
    text-align: center; /* will center text in <p>, which is not a flex item */
    .ion {
      font-size: 40px;
    }
  }

  &:hover {
    //background-color: lighten($yellow, 20%);
    color: $yellow;
    border-color: $yellow;
  }
}
</style>
